import {MechanicLongestRoadPlayerState, MechanicLongestRoadState, PlayerColor} from '@colonist/game-states'
import {MechanicValidator} from './MechanicValidator'
import {PlayerValidator} from '../core/PlayerValidator'
import {MapValidator} from '../core/map/MapValidator'

export class MechanicValidatorLongestRoad extends MechanicValidator {
    private readonly longestRoadState: MechanicLongestRoadState

    constructor(playerValidators: PlayerValidator[], mapValidator: MapValidator, longestRoadState: MechanicLongestRoadState) {
        super(playerValidators, mapValidator)

        this.longestRoadState = longestRoadState
    }

    getLongestRoadPlayerState(player: PlayerColor): MechanicLongestRoadPlayerState {
        if(player == PlayerColor.None) {
            return {
                longestRoad: 0,
            }
        }
        const longestRoadPlayerState = this.longestRoadState[player]
        if(longestRoadPlayerState === undefined) throw new Error(`No longestRoadPlayerState for player ${player}`)

        return longestRoadPlayerState
    }

    getPlayerWithLongestRoadCard(): PlayerColor {
        for(const key in this.longestRoadState) {
            const playerColor = Number(key) as PlayerColor
            const longestRoadPlayerState = this.getLongestRoadPlayerState(playerColor)
            if(longestRoadPlayerState.hasLongestRoad) return playerColor
        }

        return PlayerColor.None
    }

    doesBankHaveLongestRoadCard(): boolean {
        const playerWithLongestRoadCard = this.getPlayerWithLongestRoadCard()
        return playerWithLongestRoadCard == PlayerColor.None
    }
}
